module.exports = __webpack_public_path__ + "img/menu-zonglan.9c10db2a.svg";